import { 
  ShoppingCart, Factory, Wheat, Pill, Cog, Wind, Egg, Wine, 
  FlaskConical, Car, HardHat, UtensilsCrossed, GraduationCap, Shield,
  Building2, AlertCircle, Search, PenTool, Code, CheckCircle, Rocket, 
  Headphones, Clock, DollarSign, TrendingUp, Users, Zap, Target,
  LayoutDashboard, Settings, MapPin, UserCog, Image, LogOut, ChevronRight,
  ArrowRight, Sparkles, BarChart3, Briefcase, Globe, Award, Building,
  Smartphone, Fish, Milk, Play, Timer, PiggyBank
} from "lucide-react";

export const iconMap = {
  ShoppingCart,
  Factory,
  Wheat,
  Pill,
  Cog,
  Wind,
  Egg,
  Wine,
  FlaskConical,
  Car,
  HardHat,
  UtensilsCrossed,
  GraduationCap,
  Shield,
  Building2,
  Building,
  AlertCircle,
  Search,
  PenTool,
  Code,
  CheckCircle,
  Rocket,
  Headphones,
  Clock,
  DollarSign,
  TrendingUp,
  Users,
  Zap,
  Target,
  LayoutDashboard,
  Settings,
  MapPin,
  UserCog,
  Image,
  LogOut,
  ChevronRight,
  ArrowRight,
  Sparkles,
  BarChart3,
  Briefcase,
  Globe,
  Award,
  Smartphone,
  Fish,
  Milk,
  Play,
  Timer,
  PiggyBank
};

export const getIcon = (iconName, className = "h-5 w-5") => {
  const IconComponent = iconMap[iconName] || Building2;
  return <IconComponent className={className} />;
};
